<template>
  <div class="swiper-imgs">
    <van-swipe @change="onChange" height="260px">
      <!-- imgLink 可能会重复 -->
      <van-swipe-item v-for="(imgLink, key) in imgList" :key="key" @click="clickSwipe" :initial-swipe="current">
        <div class="swiper-slide">
          <van-image
            class="no-down-img"
            :src="imgLink"
            alt="商品主图"
            fit="cover"
            loading-icon="zylogo"
            error-icon="zylogo"
            width="100%"
            height="100%"
          ></van-image>
        </div>

        <span class="rx-shade" v-if="showShade" :style="rxShadeStyle">
          {{ rxShadeConfig['shop-compliance-content']['tips'] }}
        </span>
      </van-swipe-item>

      <div class="custom-indicator flex center" slot="indicator">
        {{ current + 1 + '/' + imgList.length }}
      </div>
    </van-swipe>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem, Image } from '@zyf2e/capui-mobile';
import { RxTypeNum } from '@/constant';
import { mapState } from 'vuex';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Image);

export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(['rxShadeConfig']),
    showShade() {
      return this.item.attribute === RxTypeNum.CHUFANGYA0 && this.rxShadeConfig['shop-compliance-open'];
    },
    rxShadeStyle() {
      const content = this.rxShadeConfig['shop-compliance-content'];
      return {
        color: `#${content.textColor}`,
        background: `#${content.bgColor}`,
        opacity: content.alpha,
        fontSize: `${content.textSize}px`
      };
    }
  },
  methods: {
    clickSwipe() {
      if (!this.showShade) {
        this.$emit('clickSwipe');
      }
    },
    onChange(index) {
      this.$emit('onChange', index);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-imgs {
  .custom-indicator {
    position: absolute;
    right: 16px;
    bottom: 16px;
    width: 32px;
    height: 20px;
    color: #fff;
    font-size: 10px;
    background: rgba(51, 51, 51, 1);
    border-radius: 10px;
    opacity: 0.45;
  }

  .swiper-slide {
    height: 100vw;
    // padding-bottom: 37.5px;
    background: #fff;
    .van-image {
      text-align: center;
      display: block;
    }
  }
  .rx-shade {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
